import { render, staticRenderFns } from "./SettingsImports.vue?vue&type=template&id=3160e746&scoped=true"
import script from "./SettingsImports.vue?vue&type=script&lang=js"
export * from "./SettingsImports.vue?vue&type=script&lang=js"
import style0 from "./SettingsImports.vue?vue&type=style&index=0&id=3160e746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3160e746",
  null
  
)

export default component.exports